module.exports = __webpack_public_path__ + "img/boyko.2aabe86c.png";